import useSWR from 'swr';

import { TypeProduct } from '@/core/generated-types';

import {
  ContentfulPreviewData,
  getProductByPlaygeniusProductAnchor,
} from './contentful';

export const useGetProductByPlaygeniusProductAnchor = (
  playgeniusProductAnchor: string,
  isPreview?: boolean,
  previewData?: ContentfulPreviewData,
) => {
  const { data } = useSWR<TypeProduct, Error>(
    `getProductByPlaygeniusProductAnchor_${playgeniusProductAnchor}`,
    () =>
      getProductByPlaygeniusProductAnchor(
        playgeniusProductAnchor,
        isPreview,
        previewData,
      ),
  );

  return data;
};
